import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";

const DisapproveCustomer = ({ show, closeModal, refreshPage, customerId }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    
    try {
      // Using the same endpoint as approve but with status parameter set to inactive
      const response = await axiosInstance.post(`/user/customer/approve_status/${customerId}`, {
        status: 'inactive'
      });
      
      toast.success(response.data.message);
      closeModal();
      refreshPage();
    } catch (error) {
      console.error("Error disapproving customer:", error);
      toast.error(error.response?.data?.message || "Failed to disapprove customer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={closeModal} centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title>Disapprove Customer</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-light">
        <p>Are you sure you want to disapprove this customer?</p>
        <p className="text-muted small">This action will change the customer status to inactive.</p>
      </Modal.Body>
      <Modal.Footer className="bg-light">
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button 
          variant="danger" 
          onClick={handleConfirm} 
          disabled={loading}
        >
          {loading ? "Disapproving..." : "Disapprove"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DisapproveCustomer;